

import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import App from './App'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import ToastPlugin from 'vux/src/plugins/toast/index.js'

import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import DatetimePlugin from 'vux/src/plugins/datetime/index.js'

import util from './libs/util'
import datas from './libs/datas'
import store from '@/store/store'
import VueCookies from 'vue-cookies'

import '../static/fontIcon/iconfont.css'
import './assets/style/common.scss'

FastClick.prototype.focus = function (targetElement) {
let length
if (util.browser.ios && targetElement.setSelectionRange
&& targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
length = targetElement.value.length
targetElement.focus()
targetElement.setSelectionRange(length, length)
} else {
targetElement.focus()
}
}
FastClick.prototype.needsClickForParent = function (target) {
let parent = target.parentNode
if (parent == null) {
return false
}
let b = (/\bneedsclick\b/).test(parent.className)
if (!b) {
return this.needsClickForParent(parent)
} else {
return true
}
}
FastClick.prototype.needsClick = function (target) {
if (this.needsClickForParent(target) === true) {
return true
}
switch (target.nodeName.toLowerCase()) {


case 'button':
case 'select':
case 'textarea':
if (target.disabled) {
return true
}
break
case 'input':

if ((util.browser.ios && target.type === 'file') || target.disabled) {
return true
}
break
case 'label':
case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
case 'video':
return true
}

return (/\bneedsclick\b/).test(target.className)
}
FastClick.attach(document.body)

Vue.config.productionTip = false
Object.defineProperty(Vue.prototype, '$cookies', {value: VueCookies})
Object.defineProperty(Vue.prototype, '$util', {value: util})
Object.defineProperty(Vue.prototype, '$datas', {value: datas})

Vue.use(WechatPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin, {position: 'top', type: 'text'})
Vue.use(DatetimePlugin)


Vue.filter('filterCdn', function (url) {
if (url.indexOf("http") > -1){
return url
} else {
return util.cdn + url
}
})

var _hmt = _hmt || [];
window._hmt = _hmt; 
(function () {
var hm = document.createElement("script");
hm.src = "https://hm.baidu.com/hm.js?0a75895d31140001bfbb3647dde5b086";
var s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(hm, s);
})();

/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App),
created: function () {
const token = util.getQueryString('token')
store.dispatch('getSiteInfo', token)
}
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js